
import Vue from 'vue';

// 组件注册表管理器增强版
const componentRegistry = {
    registered: {},
    count: 0,

    register(name, component) {
        if (!this.registered[name]) {
            Vue.component(name, component);
            this.registered[name] = {
                instance: component,
                refCount: 1 // 引用计数器
            };
            this.count++;
        } else {
            this.registered[name].refCount++;
        }
    },

    unregister(name) {
        if (this.registered[name]) {
            this.registered[name].refCount--;
            if (this.registered[name].refCount <= 0) {
                delete Vue.options.components[name];
                delete this.registered[name];
                this.count--;
            }
        }
    },
    // 新增：注销所有组件的方法
    unregisterAll() {
        Object.keys(this.registered).forEach(name => {
            // 直接删除所有已注册的组件，不管引用计数
            delete Vue.options.components[name];
            delete this.registered[name];
        });
        this.count = 0;
    },

    getRegisteredCount() {
        return this.count;
    },

    listRegistered() {
        return Object.keys(this.registered);
    }
};

// 封装获取组件name的方法（保持不变）
const resolveComponentName = (component, componentFile = '') => {
    let componentName = (component.default || component).name;
    if (!componentName && componentFile) {
        const fileName = componentFile.replace(/^.*\/([^/]+)\.js/, '$1');
        if (fileName !== 'index') {
            componentName = fileName;
        } else {
            componentName = componentFile.replace(/^(.*\/)?([^/]+)\/index\.js$/, '$2');
        }
    }
    return componentName || '';
};

const context = require.context('./', true, /^(?!\.?\/?index\.js$).*\.(js|vue)$/);

// 遍历组件并预加载但不立即注册
const componentsMap = {};
context.keys().forEach(componentFilePath => {
    const component = context(componentFilePath);
    if (component.__ignore) return;

    let componentName = resolveComponentName(component, componentFilePath);
    if (!componentName) {
        console.error(`Component ${componentFilePath} register failed, the component name is undefined`);
        return;
    }

    // 只保存到映射表中，不实际注册
    componentsMap[componentName] = component.default || component;
});

// 导出供外部使用的API
export default {
    // 手动注册单个组件
    registerComponent(name) {
        if (componentsMap[name]) {
            componentRegistry.register(name, componentsMap[name]);
        } else {
            console.warn(`Component "${name}" not found in components directory`);
        }
    },

    // 手动注销单个组件
    unregisterComponent(name) {
        componentRegistry.unregister(name);
    },
    // 新增：注销所有组件的方法
    unregisterAllComponents() {
        componentRegistry.unregisterAll();
    },

    // 根据路由自动管理的便捷方法
    manageByRoute(routeName, action = 'register') {
        if (typeof action === 'string') {
            if (action === 'register') {
                this.registerComponent(routeName);
            } else if (action === 'unregister') {
                this.unregisterComponent(routeName);
            }
        }
    },

    // 获取当前已注册的所有组件信息
    getStatus() {
        return {
            totalRegistered: componentRegistry.getRegisteredCount(),
            registeredList: componentRegistry.listRegistered(),
            allAvailable: Object.keys(componentsMap)
        };
    }
};

// // 也可以手动控制
//let componentAPI = require('@/components'); // 引入上面的模块
// componentAPI.default.registerComponent('SpecialButton'); // 手动注册
// componentAPI.default.unregisterComponent('SpecialButton'); // 手动注销